import { useParams } from 'react-router-dom';
import { useRouter } from '~/utils/navigation';
import useTranslations from '~/components/translation/use-translations';
import Loading from '~/components/misc/loading';
import { WE_SPIN_BUY_IN_TEXT_KEYS } from '../constants/we-spin-text-keys';
import { useEffect, useMemo } from 'react';
import Icon, { ICON_DOCUMENT_SEARCH_LINE } from '~/components/icon';
import { HeadWrapper, MainTitle, SubTitle } from '~/components/misc/section-head';
import { Sidebar, SidebarContent, SidebarHeader } from '~/components/sidebar';
import { LeftSideIconType } from '~/components/sidebar/sidebar-header/sidebar-header';
import { ROUTE_WE_SPIN_GAME_ROOM_BUY_IN } from '../constants/we-spin-route-constants';
import SidebarScrollAware from '~/utils/sidebar-scroll-aware';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer';
import { H4Bold } from '@comeon/ui';
import { useScrollToTopCallback } from '~/hooks/use-scroll-to-top';

const SIDEBAR_TITLE_SCROLL_THRESHOLD = 100;

const WeSpinGameRoomTos = () => {
	const params = useParams();
	const router = useRouter();

	const { translations: tr, isLoadingTranslations } = useTranslations(WE_SPIN_BUY_IN_TEXT_KEYS);

	const scrollbarScrollToTop = useScrollToTopCallback();

	const TosText = useMemo(
		() =>
			tr.WE_SPIN_BUY_IN_WESPIN_TOC_TEXT?.split('\n')
				.filter(item => item !== '')
				.map(item => <p key={item}>{item}</p>),
		[tr.WE_SPIN_BUY_IN_WESPIN_TOC_TEXT]
	);

	const transformPath = useContextualPathTransformer();

	useEffect(() => {
		scrollbarScrollToTop();
	}, [scrollbarScrollToTop]);

	if (isLoadingTranslations) return <Loading />;

	return (
		<Sidebar>
			<SidebarScrollAware>
				{scrollYPosition => (
					<SidebarHeader
						transparent={scrollYPosition < SIDEBAR_TITLE_SCROLL_THRESHOLD}
						leftSideIcon={LeftSideIconType.BACK_ICON}
						onLeftSideButtonClick={() => {
							router.push(transformPath(`${ROUTE_WE_SPIN_GAME_ROOM_BUY_IN}/${params.streamRef}`));
						}}
						className="transparent_title page-head--we-spin"
						opaqueClassName="page-head--opac"
					>
						<H4Bold className="page-head__title">
							{scrollYPosition > SIDEBAR_TITLE_SCROLL_THRESHOLD && tr.WE_SPIN_BUY_IN_WESPIN_TOC_LABEL}
						</H4Bold>
						<div className="page-head__right-side" />
					</SidebarHeader>
				)}
			</SidebarScrollAware>
			<SidebarContent>
				<HeadWrapper>
					<Icon type={ICON_DOCUMENT_SEARCH_LINE} />
					<MainTitle>{tr.WE_SPIN_BUY_IN_WESPIN_TOC_LABEL}</MainTitle>
					<SubTitle>{tr.WE_SPIN_BUY_IN_WESPIN_TOC_DESCRIPTION}</SubTitle>
				</HeadWrapper>
				<div className="u-p1">{TosText}</div>
			</SidebarContent>
		</Sidebar>
	);
};

export default WeSpinGameRoomTos;
